import { QueryClient } from '@tanstack/react-query';

import { ApiError } from './client';

/** A factory, not a singleton — tests need a fresh cache each. */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        // 4xx is an answer (unknown link, expired badge), not a blip.
        retry: (failureCount, error) =>
          !(error instanceof ApiError && error.status < 500) &&
          failureCount < 2,
        staleTime: 30_000,
      },
    },
  });
}
